// Copied (and slightly tweaked) from https://github.com/SEEK-Jobs/metropolis/tree/0cae693c8726ff197469b91a3c71a7001b596914/packages/apac-candidate-header-footer/src/ApacCandidateFooter/components/FirstNationsBanner

import { Box, Column, Columns, Stack, Text } from 'braid-design-system';

import { FirstNationsArtwork } from './FirstNationsArtwork';

export const FirstNationsBanner = () => (
  <Columns space="large" collapseBelow="tablet">
    <Column width="content">
      <FirstNationsArtwork />
    </Column>

    <Column>
      <Stack space="medium">
        <Text size="small" weight="strong" tone="secondary">
          <Box display={{ mobile: 'inline', wide: 'block' }} component="span">
            SEEK Business acknowledges the Traditional Custodians of the lands
            on which it operates its online business-for-sale marketplace.
          </Box>{' '}
          <Box display={{ mobile: 'inline', wide: 'block' }} component="span">
            The gum leaf represents a symbol of welcome and it acknowledges the
            diverse countries, environments and communities.
          </Box>
        </Text>
        <Text size="small" tone="secondary">
          Artwork by Bitja, Dixon Patten Jnr, Gunnai, Gunditjmara, Yorta Yorta
          and Dhudhuroa, Bayila Creative.
        </Text>
      </Stack>
    </Column>
  </Columns>
);
